<a href="#">
  <img src="/assets/icons/logo.svg" alt="elegro logo" />
</a>
